import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
const store = () => {
	return new Vuex.Store({
	state: {
        //通用 Start +++++++++++++++++++++++
        domain:'http://pc.miaocang.cc',
		app_build:3009000,
        app_version:'3.9.0',
		app_platform:'PC',
        //通用 End--------------------------

		//苗木管理相关 Start +++++++++++++++
		stockManager:{
            searchWarehouse:'',
            searchKeyword:'',
            searchSalesType:'',
            searchSeedlingStatus:'0',
            searchLatin:'',
		},
            //苗木推广消耗苗币值
            advCostIntegral:null,//暂时不能用，消耗是一个根据品种的动态计算，不能作为常态值
		//苗木管理相关 End -----------------

        //订单相关 Start +++++++++++++++++++
        orderFilterTmpParams:{},
        //审批级别：通过A, 驳回R, 拒绝C, 取消审批D, 删除审批W。
        //订单级别：取消订单K, 删除订单O
		orderBuyerOperations:{
			cancel_order_buyer:{
                label:"取消订单",
                api:'/uapi/purchase/buyer_audit.htm',
                requireParams: {
                    build:'',
					platform:'PC',
					order_id:'',
					status:'K',
					reason_id:''
                },
                className:'text-operation-btn c-999',
            },
			pay_order_buyer:{
                label:"付款",
                api:'pay',
                className:'button-operation-btn c-fff background-mc-green',
            },
            delete_order_buyer:{
                label:"删除订单",
                api:'/uapi/purchase/buyer_audit.htm',
                requireParams: {
                    build:'',
                    platform:'PC',
                    order_id:'',
                    status:'O',
                    reason_id:''
                },
                className:'text-operation-btn c-999',
            },
		},
        //订单级别: A:确认订单， C:取消订单,  O:删除订单
        orderSellerOperations:{
            approve_order_seller:{
                label:"确认订单",
                api:'/uapi/purchase/seller_audit.htm',
                requireParams: {
                    build:'',
                    platform:'PC',
                    order_id:'',
                    status:'A',
                    reason_id:''
                },
                className:'text-operation-btn c-333',
            },
            cancel_order_seller:{
                label:"取消订单",
                api:'/uapi/purchase/seller_audit.htm',
                requireParams: {
                    build:'',
                    platform:'PC',
                    order_id:'',
                    status:'C',
                    reason_id:''
                },
                className:'text-operation-btn c-999',
            },
            editprice_order_seller:{
                label:"改价",
                api:'/uapi/order/prices.htm',
                requireParams:[
                    "build","gmt_modify","order_id","shipping_fee","platform",
                    "other_cost","total","items",//items: [{"price": "20174","id": "733"},{"price": "24143","id": "734"}]
                ],
                className:'text-operation-btn c-333',
            },
            delete_order_seller:{
                label:"删除订单",
                api:'/uapi/purchase/seller_audit.htm',
                requireParams: {
                    build:'',
                    platform:'PC',
                    order_id:'',
                    status:'O',
                    reason_id:''
                },
                className:'text-operation-btn c-999',
            },
            //订单相关 End -----------------
        },
	},
	mutations: {
		setStockManagerSearchKeyword(state,n) {
			state.stockManager.searchKeyword = n;
		},
        setStockManagerSearchWarehouse(state,n) {
			state.stockManager.searchWarehouse = n;
		},
        setStockManagerSearchSalesType(state,n) {
            state.stockManager.searchSalesType = n;
        },
        setStockManagerSearchSeedlingStatus(state,n) {
            state.stockManager.searchSeedlingStatus = n;
        },
        setStockManagerSearchLatin(state,n) {
            state.stockManager.searchLatin = n;
        },
		setOrderFilterTmpParams(state,n){
			state.orderFilterTmpParams = n;
		},
        setAdvCostIntegral(state,n){
            state.advCostIntegral = n;
        },
	}
})
};
export default store


// WEBPACK FOOTER //
// ./src/store/index.js